import { useEffect, useMemo } from "react";
import { SelectField } from "../../components";
import { useFormContext } from "react-hook-form";
import { RootState } from "../../store/root-reducer";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { MiniPlanCard } from "../../components/PlanCard";

function ItemDetailes({ claimOptions, warranty_items, claim_items, plan }) {
  const { register, getValues } = useFormContext();
  const { t } = useTranslation();
  const { materialOptions, colorOptions, manufacturersOptions } =
    useMemo(() => {
      const {
        colors = [],
        materialTypes = [],
        manufacturers = [],
      } = claimOptions;
      const materialOptions = materialTypes.map((v) => ({
        label: v.name,
        value: v.name?.toString(),
      }));
      const colorOptions = colors.map((v) => ({
        label: v.name,
        value: v.name?.toString(),
      }));
      const manufacturersOptions = manufacturers.map((v) => ({
        label: v.name,
        value: v.name?.toString(),
      }));
      return {
        materialOptions,
        colorOptions,
        manufacturersOptions,
      };
    }, [claimOptions]);

  const selected_warranty_items = getValues("selectedItems");

  const filtered_selected_warranty_items = useMemo(() => {
    const claimItemWarrntyIds = claim_items.map(
      ({ warrantyItem }) => warrantyItem?.id
    );
    return (
      warranty_items
        .filter(
          (item) =>
            selected_warranty_items.includes(item?.id) ||
            claimItemWarrntyIds.includes(item?.id)
        )
        .map((warrItem) => {
          const claimItem = claim_items.find(
            ({ warrantyItem }) => warrantyItem?.id === warrItem?.id
          );
          return {
            ...warrItem,
            claimItemId: claimItem?.id,
            manufacturer:
              claimItem?.manufacturer || warrItem?.manufacturer || "",
            material: claimItem?.material || warrItem?.material || "",
            color: claimItem?.color || warrItem?.color || "",
          };
        }) || []
    );
  }, [claim_items, selected_warranty_items, warranty_items]);

  if (filtered_selected_warranty_items.length === 0) {
    return (
      <div className="justify-center flex items-center flex-col py-8 text-center text-3xl font-semibold text-gray-700 ">
        <input type="hidden" {...register("temp", { required: true })} />
        <div className="w-96">
          {t("Please select some items on 2")}
          <sup>nd</sup> step
        </div>
      </div>
    );
  }

  return (
    <div>
      <MiniPlanCard plan={plan} />
      <div className="space-y-5 mt-5">
        {filtered_selected_warranty_items.map((item, idx) => (
          <ClaimItemBox
            idx={idx}
            item={item}
            key={item.id}
            colorOptions={colorOptions}
            materialOptions={materialOptions}
            manufacturersOptions={manufacturersOptions}
          />
        ))}
      </div>
    </div>
  );
}

const ClaimItemBox = ({
  idx,
  item,
  colorOptions,
  materialOptions,
  manufacturersOptions,
}) => {
  const { control, setValue } = useFormContext();
  useEffect(() => {
    if (item?.claimItemId) {
      setValue(`claimItems.[${item.id}].claimItemId`, item.claimItemId);
    }
    setValue(`claimItems.[${item.id}].name`, item.name);
    setValue(
      `claimItems.[${item.id}].warranty_line_item_guid`,
      item.warranty_line_item_guid
    );
    return () => {};
  }, [item, setValue]);

  return (
    <div className="space-y-2" key={item.id}>
      <div className="bg-[#EBEEEF] min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
        <span className="size-5 flex justify-center items-center  bg-white rounded-full p-3">
          {idx + 1}
        </span>
        <div className="text-black font-semibold  block">{item?.name}</div>
      </div>
      <SelectField
        label="Manufacturer"
        control={control}
        required
        placeholder="Select Manufacturer"
        defaultValue={item.manufacturer}
        name={`claimItems.[${item.id}].manufacturer`}
        options={manufacturersOptions}
      />
      <SelectField
        required
        label="Material"
        defaultValue={item.material}
        placeholder="Select Material"
        control={control}
        name={`claimItems.[${item.id}].material`}
        options={materialOptions}
      />
      <SelectField
        required
        label="Color"
        defaultValue={item.color}
        control={control}
        placeholder="Select Color"
        name={`claimItems.[${item.id}].color`}
        options={colorOptions}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  claimOptions: state?.user?.claimOptions || {},
  warranty_items: state?.ace2Claim?.warranty_items || [],
  claim_items: state?.ace2Claim?.claim_items || [],
  plan: state?.ace2Claim?.plan || {},
});

export default connect(mapStateToProps)(ItemDetailes);
